import { Pipe, PipeTransform } from "@angular/core";
import { IObservationResume, IOComponent } from "@comunicare/comunicare-interfaces";
import { Observation } from "src/app/models/observations.model";

@Pipe({ name: "isBluetoothObsComp" })
export class IsBluetoothObsCompPipe implements PipeTransform {
  transform(obs: Observation | IObservationResume, header?: IOComponent): boolean {
    const parentObs =
      (obs as Observation)?.component?.find((c) => c.code.coding[0].code === header?.code.coding[0].code)?.parentObservation ??
      header?.parentObservation;
    if (parentObs) {
      if (parentObs.device?.reference && parentObs.device?.componentAnswer?.length > 0) {
        const res =
          parentObs.device.componentAnswer.findIndex((c) => {
            return c.loinc === (header?.code?.coding ? header.code.coding[0].code : (obs as IObservationResume).reference);
          }) !== -1;
        return res;
      }
    } else if (obs?.device?.reference && obs?.device?.componentAnswer?.length > 0) {
      const res =
        obs.device.componentAnswer.findIndex((c) => {
          return c.loinc === (header?.code?.coding ? header.code.coding[0].code : (obs as IObservationResume).reference);
        }) !== -1;
      return res;
    } else {
      return false;
    }
  }
}
